import { render } from "./PaymentMethodsCard.vue?vue&type=template&id=2d04a10c"
import script from "./PaymentMethodsCard.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__